import script from "./videoItem.vue?vue&type=script&setup=true&lang=js"
export * from "./videoItem.vue?vue&type=script&setup=true&lang=js"

import "./videoItem.vue?vue&type=style&index=0&id=4cb5c985&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cb5c985"]])

export default __exports__